import AnswerPerformance from 'models/answer_performance';
import createConverter from './lib/create_converter';

export default createConverter(AnswerPerformance);
